import { api } from "@/api";
import { BettingSelectionWithTranslations } from "@/types/ApiResponses/BettingSelection";

export const getBettingSelectionWithTranslations = async (
  id: number
): Promise<BettingSelectionWithTranslations> => {
  const res = await api.client.get(`/betting-selections-new/with-translations/${id}`);
  return res.data;
};
